export default __webpack_public_path__ + "static/media/logo-black.d637f38e.png";